<style lang="less" scoped>
.contents {
  padding-top: 30px;
}
</style>
<template>
  <div v-if="identifier" class="contents">
    <iframe
      ref="iFrame1"
      width="100%"
      frameborder="0"
      @load="setupListener"
      :src="link"
    ></iframe>
  </div>
</template>
<script>
import Vue from "vue";
import { Indicator } from "mint-ui";
import { Loadmore } from "mint-ui";
export default {
  components: {
    [Loadmore.name]: Loadmore,
    [Indicator.name]: Indicator,
  },
  data() {
    return {
      identifier: "",
      link: "",
    };
  },
  mounted() {
    this.identifier = this.$route.query.cstr;
    this.link = this.$url.api + "portal/detail?identifier=" + this.identifier;
  },
  methods: {
    setupListener() {
      window.addEventListener("message", this.receiveMessage, false);
    },
    receiveMessage(event) {
      // 检查消息来源
      // if (event.origin !== "http://localhost:8000") {
      //   return;
      // }
      const { height } = event.data;
      console.log(height);
      if (typeof height === "number") {
        this.$refs.iFrame1.style.height = `${height}px`;
      }
    },
  },
};
</script>